export const ORDER_ITEM_STATUSES = {
  NONE: 100,
  TAKEN: 200,
  MISSING: 500,
  RETURNED: 1000,
};
